var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.87 168.09",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.39 43.66a16.77 16.77 0 01-16.45-16.5 17 17 0 0116.47-16.52c8.66 0 16.58 7.88 16.54 16.54s-7.81 16.51-16.56 16.48z",
    fill: "#26c2be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.45 125.19a3.86 3.86 0 01-1.25-3c0-16.64.24-33.3-.17-49.93a52.85 52.85 0 00-5.25-22 2.26 2.26 0 00-2.19-1.26h-1.22a22.26 22.26 0 01-21.84-21.9v-1.22a2.26 2.26 0 00-1.24-2.2 56.21 56.21 0 00-10-3.71 2.1 2.1 0 01-1.83-2.49 28.94 28.94 0 00-.36-7C85.85 5.09 82.32 1.75 77.1.3l-.58-.16a2.33 2.33 0 00-.78-.14h-2.68a2.37 2.37 0 00-.65.09 15.42 15.42 0 00-7.34 4.12 13.86 13.86 0 00-3.74 10.06c0 1.66.52 3.76-.27 4.87s-2.93 1.14-4.46 1.7c-20.68 7.59-33.61 22.1-38 44a60.7 60.7 0 00-.91 11.68c-.1 15.2-.06 30.4 0 45.61a3.85 3.85 0 01-1.24 3C11.14 130.47 5.9 135.8.65 141.12a2.26 2.26 0 00-.65 1.59v5.54a2.23 2.23 0 002.21 2.22h52.14a2.29 2.29 0 012.25 2 17.86 17.86 0 005.63 10.72 20.59 20.59 0 009.5 4.82 2.25 2.25 0 00.58.07H77a1.54 1.54 0 01.44-.26A18.09 18.09 0 0091 157.37a15.19 15.19 0 001.49-4.93 2.23 2.23 0 012.24-2h52a2.23 2.23 0 002.22-2.22v-5.54a2.27 2.27 0 00-.66-1.59c-5.29-5.29-10.56-10.62-15.84-15.9z",
    fill: "#fca943"
  }))));
}

export default SvgNotificationactive;